import * as React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Root } from './component/root/Root'
import './resources/AntStyles/AntDesign/antd.cleanui.css'
import './resources/CleanStyles/Core/core.cleanui.css'

ReactDOM.render(
    <BrowserRouter>
        <Root />
    </BrowserRouter>, document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/index.tsx